export default "__VITE_ASSET__460bea3a__"